import { toast, TOAST_REMOVE_DELAY } from "../hooks";

/**
 * Custom fetch mutator for Orval
 * This ensures that non-2xx HTTP responses throw errors,
 * so React Query's onError callback is called instead of onSuccess
 */
export const customFetch = async <T = any>(url: string, config: RequestInit): Promise<T> => {
  const response = await fetch(url, config);

  const body = [204, 205, 304].includes(response.status) ? null : await response.text();

  const data = body ? JSON.parse(body) : {};

  if (response.status < 400) {
    return {
      data,
      status: response.status,
      headers: response.headers,
    } as T;
  }

  const errorMessage = data?.message ?? String(response.status);

  if (config.method === "GET") {
    const { dismiss } = toast({
      title: "Ошибка",
      description: errorMessage,
      variant: "destructive",
    });

    setTimeout(() => dismiss(), TOAST_REMOVE_DELAY);
  }

  const error: any = new Error(errorMessage);
  error.status = response.status;
  error.response = data;

  throw error;
};
